import { Badge, Box } from "@hightouch/htui";

import { useEmailHasDynamicContent } from "src/pages/projects/library/canvas/canvas-email-slots";

/** Marks an email whose content changes by recipient, which only its editor shows. */
export function DynamicContentBadge({
  emailId,
}: {
  emailId: string | undefined;
}) {
  if (!useEmailHasDynamicContent(emailId)) return null;
  return (
    <Box flexShrink={0}>
      <Badge size="sm">Dynamic content</Badge>
    </Box>
  );
}
